import CardsList from "@/components/cardsList";
import { USECASES_CONSTANTS } from "./constants";

const UseCasesComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 3 }}
      title={USECASES_CONSTANTS.title}
      desc={USECASES_CONSTANTS.desc}
      list={USECASES_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
      hoverEffect
    />
  );
};

export default UseCasesComponent;
